import { APP_CONFIGS } from './../_constants/config.constants';

export const msalConfigs = {
	auth: {
	  clientId: APP_CONFIGS.CLIENT_ID,
	  authority: APP_CONFIGS.AUTHORITY,
	  redirectUri: APP_CONFIGS.REDIRECT_URL
	},
	cache: {
	  cacheLocation: 'localStorage', // This configures where your cache will be stored
	  storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
	}
  }
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
	scopes: APP_CONFIGS.API_SCOPE
  }
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
  //   graphMeEndpoint: 'Enter_the_Graph_Endpoint_Here/v1.0/me'
  }